import { ApiGetCall } from '../../../JS/Connector';
import { formatDateToMMDDYYYY, HideLoder, LogInSchoolID, ShowLoder } from '../../../JS/Common';
import { useState } from 'react';
import AlertsComp from '../../../Components/AlertsComp';

export default function Exportdevices({ FilterData, setAlerts }) {
    const [loading, setLoading] = useState(false);

    async function ExportInventory(flag) {
        setLoading(true);

        setTimeout(() => {
            setLoading(false);
            setAlerts(<AlertsComp show={true} variant="success" msg={`You will receive an email notification once matching data is found and processed.`} />);
        }, 2000);

        setTimeout(() => {
            setAlerts(<AlertsComp show={false} />);
        }, 5000);

        setTimeout(() => {
            ApiGetCall(`/inventory/export?schoolId=${LogInSchoolID}&flag=${flag}&startDate=${formatDateToMMDDYYYY(FilterData.StartDate)}&endDate=${formatDateToMMDDYYYY(FilterData.EndDate)}`, null, true)
        }, 0);
    }

    return (
        <>
            {loading ? <ShowLoder /> : <HideLoder />}
            <div className='row d-flex align-items-center p-1'>
                <span className='GridTitle'>Export Devices</span>
            </div>
            <div className='col-12'>
                <img src='/images/HorizontalLine.svg' className='img-fluid w-100' />
            </div>
            <div className="p-2">
                <p className="text-justify" style={{ fontSize: "13px" }}>
                    Want to export your devices? For active devices click on the "Export Active Devices" button. For decommissioned devices click on the "Export Decommissioned Devices" button. For loaner devices click on the “Export Loaner Devices" button. For all devices click on the "Export All" button below
                </p>
                <div className="row p-3">
                    <div className="col-md-12 px-0 py-2">
                        <label className='BorderBtnForimportExport' onClick={(e) => ExportInventory(1)}>Export Active Devices
                            <img src='/images/ExportInventory.svg' className='img-fluid ps-2' />
                        </label>
                    </div>
                    <div className="col-md-12 px-0 py-2">
                        <label className='BorderBtnForimportExport' onClick={(e) => ExportInventory(2)}>Export Decommissioned Devices
                            <img src='/images/ExportInventory.svg' className='img-fluid ps-2' />
                        </label>
                    </div>
                    <div className="col-md-12 px-0 py-2">
                        <label className='BorderBtnForimportExport' onClick={(e) => ExportInventory(3)}>Export Loaner Devices
                            <img src='/images/ExportInventory.svg' className='img-fluid ps-2' />
                        </label>
                    </div>
                    <div className="col-md-12 px-0 py-2">
                        <label className='BorderBtnForimportExport' onClick={(e) => ExportInventory(4)}>Export All
                            <img src='/images/ExportInventory.svg' className='img-fluid ps-2' />
                        </label>
                    </div>
                </div>
            </div>
        </>
    )
}
